import { Injectable } from '@angular/core';
import { NexusApiService } from '@df/api/nexus/nexus-api.service';
import { Nexus } from '@tomandco/nexus-api-types';
import { NSamples } from '@df/samples/samples.namespace';

@Injectable({
    providedIn: 'root'
})
export class SampleasNexusApiOverrideService extends NexusApiService {
    readonly checkout = {
        /**
         * Load checkout data
         */
        load: (data: Nexus.Api.Checkout.Load.Request) =>
            this.sendXHR<Nexus.Api.Checkout.Load.Response>(Nexus.Api.Checkout.Load.path + NSamples.SAMPLE_QUOTE_SUFFIX, data),
        /**
         * Login customer
         */
        login: (data: Nexus.Api.Checkout.Login.Request) =>
            this.sendXHR<Nexus.Api.Checkout.Login.Response>(Nexus.Api.Checkout.Login.path, data),
        /**
         * Logout customer
         */
        logout: (data: Nexus.Api.Checkout.Logout.Request) =>
            this.sendXHR<Nexus.Api.Checkout.Logout.Response>(Nexus.Api.Checkout.Logout.path, data),
        /**
         * Save billing address
         */
        saveBillingAddress: (data: Nexus.Api.Checkout.SaveBillingAddress.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SaveBillingAddress.Response>(
                Nexus.Api.Checkout.SaveBillingAddress.path + NSamples.SAMPLE_QUOTE_SUFFIX,
                data
            ),
        /**
         * Save custom data
         */
        saveCustom: (data: Nexus.Api.Checkout.SaveCustom.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SaveCustom.Response>(Nexus.Api.Checkout.SaveCustom.path + NSamples.SAMPLE_QUOTE_SUFFIX, data),
        /**
         * Save email
         */
        saveEmail: (data: Nexus.Api.Checkout.SaveEmail.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SaveEmail.Response>(Nexus.Api.Checkout.SaveEmail.path + NSamples.SAMPLE_QUOTE_SUFFIX, data),
        /**
         * Save payment
         */
        savePayment: (data: Nexus.Api.Checkout.SavePayment.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SavePayment.Response>(Nexus.Api.Checkout.SavePayment.path + NSamples.SAMPLE_QUOTE_SUFFIX, data),
        /**
         * Save shipping address
         */
        saveShippingAddress: (data: Nexus.Api.Checkout.SaveShippingAddress.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SaveShippingAddress.Response>(
                Nexus.Api.Checkout.SaveShippingAddress.path + NSamples.SAMPLE_QUOTE_SUFFIX,
                data
            ),
        /**
         * Save shipping method
         */
        saveShippingMethod: (data: Nexus.Api.Checkout.SaveShippingMethod.Request) =>
            this.sendXHR<Nexus.Api.Checkout.SaveShippingMethod.Response>(
                Nexus.Api.Checkout.SaveShippingMethod.path + NSamples.SAMPLE_QUOTE_SUFFIX,
                data
            ),
        /**
         * Submit
         */
        submit: (data: Nexus.Api.Checkout.Submit.Request) =>
            this.sendXHR<Nexus.Api.Checkout.Submit.Response>(Nexus.Api.Checkout.Submit.path + NSamples.SAMPLE_QUOTE_SUFFIX, data),
        /**
         * Load success data
         */
        success: (data: Nexus.Api.Checkout.Success.Request) =>
            this.sendXHR<Nexus.Api.Checkout.Success.Response>(Nexus.Api.Checkout.Success.path, data),

        paymentCapture: (data: Nexus.Api.Checkout.PaymentCapture.Request) =>
            this.sendXHR<Nexus.Api.Checkout.PaymentCapture.Response>(Nexus.Api.Checkout.PaymentCapture.path, data),

        paymentCancel: (data: Nexus.Api.Checkout.PaymentCancel.Request) =>
            this.sendXHR<Nexus.Api.Checkout.PaymentCancel.Response>(Nexus.Api.Checkout.PaymentCancel.path, data)
    };
}
